// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders `children` at the end of <body>. A tile's `backdrop-filter` makes it
 * the containing block of any `position: fixed` descendant, so a modal
 * (FormDialog) or the floating PartBar rendered inside a tile would be
 * clipped to it; through the portal they sit over the whole shell.
 */
export function Portal({ children }: { children: ReactNode }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
